export default {
	addressTile: {
		deliveryNotificationPhone: "Delivery notification: {phone}",
		invoiceSentVia: "Invoice will be sent by {method}",
		invoiceMethodEmail: "Email",
		invoiceMethodPost: "Post",
		applyAddressButton: "Use",
		preferredTooltipAlreadySet:
			"This address is already marked as a favourite and will be preselected for your orders.",
		preferredTooltipSetAsFavorite:
			"Set as favourite. This address will be preselected for your orders.",
		editAddressTooltip: "Edit address",
		editPermissionMissingTooltip: "Permission to edit the address is not available",
		deleteAddressTooltip: "Delete address",
		deletePermissionMissingTooltip: "Permission to delete the address is not available",
		deleteAddressDialog: {
			title: "Delete address",
			text: "Are you sure you want to delete this address?",
			deleteButtonTooltip: "Permanently deletes the address.",
			deleteButton: "Delete",
		},
	},
	addressesOverview: {
		createAddressButton: "Create new address",
	},
	changeAddress: {
		newAddressTitle: "Create new address",
		editAddressTitle: "Change address",
		firstNameLabel: "First name",
		lastNameLabel: "Last name",
		companyLabel: "Company",
		streetLabel: "Street / No.",
		zipLabel: "Postcode",
		townLabel: "Town",
		countryHint: "The country cannot be changed. Please contact us at info@blexon.com",
		deliveryPhoneLabel: "Phone number for delivery notification",
		invoiceEmailLabel: "Email address for invoice delivery",
		invoiceByEmailLabel: "Invoice by email",
		invoiceByPostLabel: "Invoice by post",
		shippingMethodLockedText: "The delivery method can no longer be changed for this order.",
		saveButtonTooltip: "Saves the changes.",
		invalidZipMessage: "Must be a valid postcode.",
		messages: {
			saveSuccess: "Address saved successfully.",
			saveError: "The address could not be saved.",
		},
	},
	customerSettings: {
		customerNumberLabel: "Your customer number",
		customerNumberHint: "This number is permanently assigned and cannot be changed.",
		personalAccountLabel: "Personal / private account",
		companyNameLabel: "Company name",
		vatNumberLabel: "VAT number / VAT ID",
		useCompanyAccountLabel: "Use as company account",
		streetLabel: "Street / No.",
		zipLabel: "Postcode",
		townLabel: "Town",
		countryLabel: "Country",
		generalPhoneLabel: "Phone (general)",
		accountEmailLabel: "Customer account email",
		accountEmailHint: "This address is used as an alternative to the user's email.",
		defaultOrderNotificationEmailLabel: "Default email for additional order notifications",
		defaultOrderNotificationEmailHint:
			"During the ordering process, an additional email address can be provided, which will also be informed about the order. If an email is provided in the field above, it is used as the default address and filled in automatically.",
		correspondenceLanguageLabel: "Correspondence language",
		correspondenceLanguageHint:
			"This is the language in which all documents such as order confirmations and invoices, as well as all emails to you, are created.",
		requiredMessage: "This field is required",
		whitespaceOnlyMessage: "The entry cannot consist of whitespace only.",
		maxLength50Message: "A maximum of 50 characters is allowed.",
		companyNamePrivateMessage: "Company name may not be 'privat'.",
		invalidZipMessage: "Must be a valid postcode.",
		messages: {
			saveSuccess: "Settings saved successfully.",
			saveError: "Settings could not be saved.",
		},
	},
	userManagement: {
		addUserButton: "Add user",
		emailChangeHint:
			"Note: to change the email address of the current user, please use the function in the {userSettingsLink}.",
		userSettingsLinkText: "user settings",
		pendingConfirmationTooltip: "Confirmation of the invited user is still pending.",
		contextMenuTooltip: "Opens the context menu for the user.",
		deleteMenuItem: "Delete",
		manageUsersLabel: "Manage users",
		orderDirectlyLabel: "Order",
		orderIndirectlyLabel: "Request order",
		changeDeliveryAddressLabel: "Change delivery addresses",
		changeInvoiceAddressLabel: "Change invoice addresses",
		ownUserRightsTooltip: "The rights of your own user account cannot be adjusted.",
		unconfirmedUserRightsTooltip: "Rights can only be adjusted once the user is confirmed.",
		manageUsersMinimumTooltip: 'At least 1 user must always have the "Manage users" right.',
		manageUsersDescriptionTooltip:
			"The user can add further users, delete users and edit the rights of all users.",
		orderDirectlyMinimumTooltip: 'At least 1 user must always have the "Order" right.',
		orderDirectlyDescriptionTooltip: "The user can place orders subject to payment.",
		orderIndirectlyDescriptionTooltip:
			"The user can prepare orders and send them for confirmation to a user with the appropriate permission.",
		changeDeliveryAddressDescriptionTooltip: "The user can change the delivery addresses.",
		changeInvoiceAddressDescriptionTooltip: "The user can change the invoice addresses.",
		noPermissionText: "Permission for user management is not available.",
		addUserDialogTitle: "Add user",
		newUserEmailPlaceholder: "Email of the new user",
		newUserRightsLabel: "Rights of the new user",
		addButton: "Add",
		deleteUserDialog: {
			title: "Are you sure?",
			text: "Do you really want to remove the user {username} from the account?",
			confirmButton: "Remove",
		},
		messages: {
			loadUserIdError: "Error loading the user ID.",
			loadUsersError: "Error loading the users.",
			saveClaimSuccess: "Permission saved successfully.",
			saveClaimError: "Error saving the permission.",
			inviteSuccess: "Invitation successfully sent to the user.",
			inviteError: "Error sending the invitation to the user.",
			removeUserError: "Error deleting the user.",
		},
	},
};
